<h4>{{ "Notifications" | translate }}</h4>
<div class="card elevated border-0">
	@if (!!messages().length) {
	<h5>{{ "Messages" | translate }}</h5>
	} @else {
	<h5>{{ "Messages_None" | translate }}</h5>
	}

	<div class="d-flex flex-column gap-2">
		@for (message of messages(); track message) {
		<div
			class="d-flex flex-row gap-2 message elevated"
			(click)="showMessage(message.Id)"
			[ngClass]="{
                  'bg-base-1': message.IsNew,
                  'bg-base-4': !message.IsNew
                }"
		>
			<div
				class="message-circle"
				[ngClass]="{
                        'bg-base-1': message.IsNew,
                        'bg-base-4': !message.IsNew
                      }"
			>
				@if (message.IsNew) {
				<img
					src="../assets/images/nordea/icons/svg/mail_unread.svg"
					height="35"
					width="35"
					class="my-auto mx-auto filter-white"
				>
				} @if (!message.IsNew) {
				<img
					src="../assets/images/nordea/icons/svg/mail_read.svg"
					height="35"
					width="35"
					class="my-auto mx-auto filter-white"
				>
				}
			</div>
			<div class="d-flex flex-row gap-2 align-items-center flex-1">
				<div class="d-flex flex-column gap-2 flex-1">
					<h5 class="mb-0">{{ message.Subject }}</h5>
					<p class="mb-0 description">
						{{ message.CreatedDate.Iso | date : "dd.MM.yyyy HH:mm" }}
					</p>
				</div>
				<img
					class="filter-white"
					[src]="'arrow-right' | icon"
					[attr.alt]="'common.arrow_right' | translate"
					width="32"
					height="32"
				>
			</div>
		</div>
		}
	</div>
</div>
